<template>
  <div class="message">
    <div class="content">
      <div class="card">
        <div class="menu">
          <div class="title active" @click="page = 'platform'">消息详情</div>
        </div>
        <div class="detail">
          <div class="title">{{title}}</div>
          <div class="handle">
            <div class="time">{{time}}</div>
          </div>
          <div class="desc" v-html="content"></div>
            <el-image
            style="width: 40%;"
                :src="img"
                :fit="'fit'"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponents from '../../components/header'
import PageComponents from '../../components/page'
import MessageItem from './components/message-item'

export default {
  name: 'setting',
  components: {
    MessageItem,
    HeaderComponents,
    PageComponents
  },
  data () {
    return {
      title: '',
      time: '',
      content: '',
      page: 'platform',
      img: ''//
    }
  },
  activated () {
    let vm = this
    let id = this.$route.params.id
    this.$request('61853a54e1df0', {
      id: id
    }).then(res => {
      vm.title = res.data.data.data.title
      vm.content = res.data.data.data.content
      vm.time = res.data.data.data.created_at
      vm.img = res.data.data.data.thumbnail
    })
  },
  methods: {
    clickDetail () {
      console.log(123)
    }
  }
}
</script>

<style lang="less">
.message {
  .ivu-steps-title {
    margin-top: 2px;
  }

  .content {
    background-color: #f7f8fa;
  }

  .card {
    background-color: #FFFFFF;
    padding: 20px;
    border-radius: 3px;

    .menu {
      display: flex;

      .title {
        font-size: 18px;
        color: #333;
        position: relative;
        margin-right: 30px;
        cursor: pointer;

      }

      .active {
        font-weight: 450;

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 70px;
          height: 3px;
          background-color: #FB9E2F;
        }
      }
    }

    .detail {
      margin-top: 40px;

      .title {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #333333;

      }

      .desc {
        font-size: 14px;
        font-weight: 400;
        line-height: 26px;
        color: #555;
        margin-top: 5px;
      }

      .handle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 5px;

        .time {
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          color: #BFBFBF;
        }
      }
    }
  }
}

</style>
